<template>
    <div class="category-item" :style="{ backgroundImage: 'url(' + backgroundImage + ')' }" @click="handleCategoryClick">
      <h1>{{ title }}</h1>
      <div class="button-category-container">
        <button>Sfoglia</button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      backgroundImage: {
        type: String,
        required: true
      },
      title: {
        type: String,
        required: true
      }
    },
    methods: {
    handleCategoryClick() {
      this.$emit('category-click', this.title);
    }
  }
  };
  </script>
  
  <style>
  .category-item {
    position: relative;
    margin: auto;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    height: 30vh;
    border-radius: 20px;
    border: solid 1px;
    border-color: var(--border-color);
    box-shadow: var(--custom-box-shadow);
    width: 100%;
  }
  
  .button-category-container {
    position: absolute;
    bottom: 0px;
    left: 0px;
    padding-left: 20px;
    padding-bottom: 15px;
  }
  
  .button-category-container button {
    background-color: rgba(120, 120, 120, 0.75);
    border: none;
    border-radius: 40px;
    padding: 5px 25px;
    color: white;
    transition: filter 0.3s ease;
  }
  
  .category-item h1 {
    color: #ffffff;
    padding-left: 15px;
    padding-top: 10px;
    font-weight: 600;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 1);
  }
  </style>
  